import * as Event from '../tools/Event';
import { MQ } from '../tools/MQ';
import { fontLoader } from './fontFaceObserver';
import { addClass, removeClass, hasClass, getItemsWidth } from '../tools/DOM';
import throttle from 'lodash.throttle';


export const init = () => {
	const element = document.querySelector('.m-breadcrumb');

	if (!element) return;

	const VISIBLE_CLASS = 'is-visible';
	const wrap = element.querySelector('.m-breadcrumb__wrap');
	const list = element.querySelector('.m-breadcrumb__list');
	const prev = element.querySelector('.m-breadcrumb__nav--prev');
	const next = element.querySelector('.m-breadcrumb__nav--next');
	const items = [...element.querySelectorAll('.m-breadcrumb__item')];
	let isInit = false;
	let pressInterval;

	const checkNav = () => {
		if (!isInit) return;

		const maxScroll = wrap.scrollWidth - wrap.clientWidth;
		const currentScroll = wrap.scrollLeft;

		if (currentScroll <= 0) {
			removeClass(prev, VISIBLE_CLASS);
		} else {
			addClass(prev, VISIBLE_CLASS);
		}

		if (currentScroll >= maxScroll) {
			removeClass(next, VISIBLE_CLASS);
		} else {
			addClass(next, VISIBLE_CLASS);
		}
	};

	const init = () => {
		if (isInit) return;

		checkNav();

		isInit = true;
	};

	const destroy = () => {
		if (!isInit) return;

		removeClass(prev, VISIBLE_CLASS);
		removeClass(next, VISIBLE_CLASS);

		isInit = false;
	};

	const update = () => {
		if (MQ('tabletMax')) return;

		const listWidth = list.offsetWidth;
		const itemsWidth = getItemsWidth(items);

		if (itemsWidth > listWidth) {
			init();
		} else {
			destroy();
		}

		checkNav();
	};

	const onPress = (event) => {
		pressInterval = setInterval(() => {
			const nav = event.target.closest('.m-breadcrumb__nav');
			let scrollLeft = 0;

			if (hasClass(nav, 'm-breadcrumb__nav--next')) {
				scrollLeft = 10;
			} else if (hasClass(nav, 'm-breadcrumb__nav--prev')) {
				scrollLeft = -10;
			}

			wrap.scrollLeft += scrollLeft;
		}, 20);
	};

	const onRelease = () => {
		clearInterval(pressInterval);
	};


	fontLoader.then(() => update());

	Event.on(window, 'resize', throttle(update, 100));
	Event.on(wrap, 'scroll', throttle(checkNav, 100));
	Event.on(prev, 'click mousedown touchstart', (event) => event.preventDefault());
	Event.on(next, 'click mousedown touchstart', (event) => event.preventDefault());
	Event.on(prev, 'mousedown touchstart', onPress);
	Event.on(next, 'mousedown touchstart', onPress);
	Event.on(prev, 'mouseup mouseleave touchend', onRelease);
	Event.on(next, 'mouseup mouseleave touchend', onRelease);
};



// WEBPACK FOOTER //
// ./src/js/components/breadcrumb.js